(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-split-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const sections = document.querySelectorAll('.css-slider-section');

    sections.forEach(section => {
      const textItems = section.querySelectorAll('.css-text-item');
      const imageTracks = section.querySelectorAll('.css-image-track');
      
      const prevBtn = section.querySelector('.prev-btn');
      const nextBtn = section.querySelector('.next-btn');
      const currentIdxDisplay = section.querySelector('.current-idx');
      const container = section.querySelector('.css-slider-container');
      
      const autoplaySpeed = parseInt(section.dataset.autoplay) || 5000;
      const totalSlides = textItems.length;
      let currentIndex = 0;
      let interval;

      function updateSlide(newIndex) {
        if (newIndex < 0) newIndex = totalSlides - 1;
        if (newIndex >= totalSlides) newIndex = 0;

        textItems[currentIndex].classList.remove('active');
        textItems[currentIndex].classList.add('inactive');

        currentIndex = newIndex;

        textItems[currentIndex].classList.remove('inactive');
        textItems[currentIndex].classList.add('active');

        const translateValue = currentIndex * -100;

        imageTracks.forEach(track => {
            track.style.transform = `translateX(${translateValue}%)`;
        });

        if(currentIdxDisplay) {
            currentIdxDisplay.textContent = currentIndex + 1;
        }
      }

      function nextSlide() { updateSlide(currentIndex + 1); }
      function prevSlide() { updateSlide(currentIndex - 1); }

      if(nextBtn) nextBtn.addEventListener('click', nextSlide);
      if(prevBtn) prevBtn.addEventListener('click', prevSlide);

      function startAutoplay() { interval = setInterval(nextSlide, autoplaySpeed); }
      function stopAutoplay() { clearInterval(interval); }

      if(container) {
        container.addEventListener('mouseenter', stopAutoplay);
        container.addEventListener('mouseleave', startAutoplay);
      }
      startAutoplay();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
